import { writable } from 'svelte/store';
import type { SessionInfo } from '../types';
import { getSessionInfo } from '../lib/apiService';
import { locale } from 'svelte-i18n';

// Initial empty settings
const initialSettings: SessionInfo = {
  active_team: { id: '', name: '', team_members: [], default_meeting_location: null, club_id: '', club: null },
  teams: [], // Empty array - user has no teams initially
  user: { id: '', username: '', email: '', email_verified: false, messaging_app: 'whatsapp' },
  language: 'nl',
  notification_preferences: []
};

export const settingsStore = writable(initialSettings);

// Function to completely clear and reset the store
export function clearSettings() {
  settingsStore.set(initialSettings);
}

// Track ongoing refresh to prevent concurrent calls
let refreshPromise: Promise<any> | null = null;

// Function to refresh settings from API
export function refreshSettings() {
  // If there's already a refresh in progress, return that promise
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = new Promise((resolve, reject) => {
    getSessionInfo((result, status) => {
      refreshPromise = null; // Clear the promise when done
      
      if (status === 200) {
        settingsStore.set(result);
        locale.set(result.language || 'nl');
        resolve(result);
      } else if (status === 401) {
        // For 401 Unauthorized, clear the store and localStorage token
        settingsStore.set(initialSettings);
        localStorage.removeItem('token');
        resolve(null);
      } else {
        // Handle other errors if needed
        reject(new Error(`Unexpected status: ${status}`));
      }
    });
  });

  return refreshPromise;
} 